export const TITLE = 'Открыть в приложении?';
export const KEY_COOKIE = 'lt-go-to-app-mobile-popup';
export const FROM_MOBILE_APP_COOKIE = 'lt-from-mobile-app';
